/* eslint-disable class-methods-use-this,max-classes-per-file */

'use strict';

define('vb/private/events/notifyWaitEventBehavior',[
  'vb/private/events/eventBehavior',
], (EventBehavior) => {
  /**
   * @typedef {import('vb/private/stateManagement/container').default} Container
   */

  /**
   * NotifyWaitEventBehavior, behavior = "notifyAndWait"
   */
  class NotifyWaitEventBehavior extends EventBehavior {
    /**
     * Calls invokeEvent in sequence.
     *
     * This method takes an array of function wrappers and executes each function
     * in sequence, ensuring that each function waits for the previous one to complete.
     * It returns a Promise that resolves once all function wrappers have been executed.
     *
     * @overrides
     * @protected
     * @param {Array<{ container: Container, fnc: function }>} functionWrappers - An array of objects where each object
     * contains a container and a function representing the event listener chain.
     * @returns {Promise} A Promise that resolves once all functions have been executed.
     */
    executeInternal(functionWrappers) {
      return functionWrappers
        .reduce((p, wrapper) => Promise.resolve(p)
          .then(() => Promise.resolve(wrapper.fnc(this))
            .then((r) => r)),
        Promise.resolve());
    }
  }

  return NotifyWaitEventBehavior;
});

